export default "__VITE_ASSET__DX91425M__"